import React from "react";
import CustomTable from "components/common/table/CustomTable";
import useBillingAmountTable from "components/pages/billingAmount/useBillingAmountTable";
import { DEFAULT_SMALL_PAGE_SIZE_OPTIONS } from "static/pagination";

const BillingAmountTable = () => {
  const { columns, data, isLoading, isFetching } = useBillingAmountTable();

  return (
    <CustomTable
      data={data ?? []}
      columns={columns}
      options={{
        state: { isLoading: isLoading || isFetching },
        enableSorting: true,
        rowsPerPageOptions: DEFAULT_SMALL_PAGE_SIZE_OPTIONS,
      }}
    />
  );
};

export default BillingAmountTable;
